import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import Swal from "sweetalert2/dist/sweetalert2.js"
import store from './store/store'
import VueForm from "vue-form"
import Multiselect from 'vue-multiselect'

import "sweetalert2/dist/sweetalert2.css"
import "vue-multiselect/dist/vue-multiselect.min.css"

import mainMixins from './mainMixins.js'

//window.$ = window.jQuery = require('jquery')

Vue.config.productionTip = false

window.INSPIRO
Vue.mixin(mainMixins)
Vue.component('multiselect', Multiselect)

window.router = router
window.apiKS = "https://sistema.etciberoamerica.com/" //Producción
//window.apiKS = "https://etcapi.test/"//"http://apietc.loc/" //Desarrollo
window.axios = axios
window.Swal = Swal
window.VueForm = VueForm
window.Fire = new Vue()
window.Vue = Vue
window.user = null
window.headers = null
window.inspiroReady = false
//window.hostname = 'store.etciberoamerica.com'//comentar para produccion
//window.apiConekta = 'key_Kf5K7iPrxBh52WmbkbrmWsA' // desarrollo
window.apiConekta = 'key_UAnsz7qgmkBmUSUQFE8CpdQ' // producción
window.hostname = location.hostname //esta linea debe estar descomentada en producción

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1000,
    timerProgressBar: true
})

window.Toast = Toast

window.clientAPI = {
    'Content-Type': 'application/json',
    //Api de producción 
    Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiYzA4YjY5ODc3ZTVlOTVkMGM4YjM0NWE3YTE0ZGVhODdmOTE0Yzc3NzZkZTMwNDI0NDgzYmE5MDNiNjZkM2NhOTE5YTUwYzVkNzFkNWYwMTUiLCJpYXQiOjE3Nzg1MTAwMjcuODkwOTk5LCJuYmYiOjE3Nzg1MTAwMjcuODkxMDAxLCJleHAiOjE4MTAwNDYwMjcuODg4NTIsInN1YiI6IjEiLCJzY29wZXMiOltdfQ.CLUBVBfgP4odILrTcy6UV0cYdbVqoh7ZlNu9n8a8GUVHPq9s5a3IT4FftDJTpGAN0rRisESETTumYtzu6bLqiApiIpnNTHYUkyGsiIeYHV1whMTq6Ph58K-aGQcBa1BJ9dZwnO8ZAu3yK55C466kE3CjIzPA2fUaIEKpe5PL786jTyDbiwM9n4xoe6E5O5eHzczpD3kmMmvMVBlPiYd4L8Kv_2TWhmWBVi_758xWDG-MObSiAwk50H6SBJQFt584FerwoTt1CaDpKHLRsMtIO2u8JirPBHpnxDH6fWiDqhz8bqAB2o46aHOhuP4mq5k1f8LACtFoUbuE-wveBtEqjkxvTmmAcm48V0P6BQXH9Q9O_uVWoZ4G1zsGD_sb9HvBHdpsrcV85QZHm8SgRGFIYoX2aMJsDZdyZgjUOMj86Wvr9JsCrxj3v2L_kqWqYyM1t5a_eC_lLYclw8xr84C0ASIRiQsOXE4urEhPCIF3Si5_TRujEAt6Q9bAWqt58kx4zS96sPTfTnIp7_Bag_gu4gQ9FpmhE8nwb3o-MaYYnuz_loRos9dME3q_Chz89hAT5o5nR7yF8VuZQaU6pW7VpNH4k2N1y-VKLS84o8VvN8OY40H-uzWwhLBarDb-iupoffnrZ6-vN-kcRwZK_16lzg4rKn36PiJagtiGFNzvqBA'
    
    //Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZFBlcnNvbiI6IjIzMzE2NyIsIm5iZiI6MTcyNDQzODgyNiwiZXhwIjoxNzU1OTc0ODI2LCJpc3MiOiJodHRwOi8vbG9jYWxob3N0OjUwMjIwIiwiYXVkIjoiTXlUZXN0QXBpIn0.7Un3XZ6T67epCdzcGrg-tgHQBSa_V0iIHt83yN4WOIM'
    //Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiZjRlMDMzNGUzOTliYjY1YzFhZTE5ZTRmZGZjOTc4MDJmNjA4Nzk4ZTM1ZGNkODZhZGFmOTk1YmFmM2EzMGNjODc5ZTk3NWJjNDgzZDE2NDAiLCJpYXQiOjE3NDI0MjU4MTUuNDU4MTMzLCJuYmYiOjE3NDI0MjU4MTUuNDU4MTM3LCJleHAiOjE3NzM5NjE4MTUuNDU0ODg3LCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.DlgHSRjRhU5YeUvUxEwKMHJIBB5vFQlR87t_q_QijqOAmhQFvnVB3yUq8zifsdgH1ag9JiLc8-G-p4_wTcmWFqdfcJY61IkaFoom0A1fhl3x8G1SfCUkVJ_KAWG06ylZq1i2SDp5vtrTxDCUKNNS2f103XWwz6_Xfg6OaSjfhIzz5MGbwDN14J-aFWMQ0fEm3MjxMvRawtm1YN6C-FBJQN5iG4XssmgIphEHOfR0cFptA9mVEaw8GKq55bDocPAM-HfQQvNHD9fJ8SKLSRa-mKPDBQ4uvXLF0k9QjafEQrNevFSBSbe2Iuv54Xrvq-yKxZfXHjD1E-hxuEOb6rrlo9Md1cT02ImYta9x8m8gQZ7d6HAqpZk1bfR51Vzmu0J0lXxJmF1lqKUok9q6S6Sp4O8P3al1YKOSPPB73lM8V6RKafyGpcHQDc6npcbyrOMfIHbTluzjNLJ7nUfAizcr5xdyQd967Z8cyrwhgjhpCmGbUI-Cgxmj05-FbFnY8RUkBT2Q4QyC5AJ6eksj6cvr6e5dHDDcNc7bTOaSrz15JtjR2R23G0GK0PdHalEUuc4fhex27ngSj62ncKVKebrjK1xOr0GM823dqyEztZhmfw_F71RzdrQZj8dKvqAlt-MOXi0SNZX1gt_VUzAlXm273eoFJ6v7e_DxoZ4d2Bp7uiQ'
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
